"use strict";

angular.module("core")
.controller("NotFoundController", function($scope, $window) {
    this.goBack = function() {
        $window.history.back();
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/http-error-response/not-found.controller.js
// module id = 406
// module chunks = 0